import { Component } from '@angular/core';
import { TableCellState } from '../../table.state';

@Component({
  selector: 'app-cell-text',
  templateUrl: './cell-text.component.html',
  styleUrls: ['./cell-text.component.scss'],
})
export class CellTextComponent extends TableCellState {}
